import {Theme, createStyles} from '@material-ui/core';
import {StyleRules} from '@material-ui/core/styles';

const tableFooterPrinterStyles = (_theme: Theme): StyleRules =>
	createStyles({
		noBottomBorder: {
			borderBottom: '0px !important',
		},
	});

export default tableFooterPrinterStyles;
